import {ApiService} from "../api";
import {PersonalData} from "../../types";
import {AxiosResponse} from "axios";
import {PersonalDataDTO} from "../../types/DTOs/PersonalDataDTO";

export class PersonalDataAPI extends ApiService{
    private constructor() {
        super();
    }

    async getPersonalData(): Promise<PersonalData> {
        const response: AxiosResponse<PersonalData> = await this.api.get('/personaldata');
        return response.data;
    }

    async getUrlPhoto(): Promise<string> {
        const response: AxiosResponse<string> = await this.api.get('/personaldata/imgurl');
        return response.data;
    }

    async createPersonalData(data: PersonalDataDTO): Promise<PersonalData> {
        const response: AxiosResponse<PersonalData> = await this.api.post('/personaldata', data);
        return response.data;
    }

    async updatePersonalData(id: string, data: Partial<PersonalDataDTO>): Promise<PersonalData> {
        const response: AxiosResponse<PersonalData> = await this.api.put(`/personaldata/${id}`, data);
        return response.data;
    }

    async deletePersonalData(id: string): Promise<void> {
        await this.api.delete(`/personaldata/${id}`);
    }
}